module.exports = __webpack_public_path__ + "img/auto_billing_banner_x2.e34558d9.png";